import React, { Fragment} from "react";
import {
  FormControlLabel,
  Checkbox,
  FormGroup,
  Typography,
  Grid,
  FormControl,
} from "@material-ui/core";
import { useStyles} from './classes'



export default function Tags({
  values,
  handleChange,
  handleBlur,
  tags,
}) {
  const groupMasterTags = (tags) => {
    if (tags && tags.length) {
      const tagMasterNames = tags.map((tag) => tag.tagMaster.name);
      return [...new Set(tagMasterNames)];
    } else {
      return [];
    }
  };

  const classes = useStyles()

  return (
    
    <Fragment>

      <Grid xs={12} sm={12} md={12} container justify="flex-start" alignItems="flex-start" >
              {groupMasterTags(tags).map((master) => (
        <Grid item xs={12} sm={6} md={6} container key={master}  >
          <Grid xs={12} sm={12} md={12} item>
            <Typography className={classes.editInfo}>
              {master}
            </Typography>
          </Grid>
          <Grid xs={12} sm={12} md={12} item >
            <FormControl>
              <FormGroup row>
                {tags
                  .filter((tag) => tag.tagMaster.name === master)
                  .map((tag) => (
                     <Grid item xs={12} sm={12} md={12} >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="tags"
                          value={tag._id}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          style ={{
                            color: "#e45826",
                          }}
                        />
                      }
                      label={tag.name}
                      key={tag._id}
                      checked={values.tags.includes(tag._id)}
                    />
                     </Grid>
                  ))}
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      ))}
      </Grid>

    </Fragment>
  );
}
